import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import cloneDeep from 'lodash/cloneDeep';

import { EventTypes } from 'src/app/core/constants/event-types';
import { Validator } from 'src/app/core/constants/validators';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
  CreateOrganizationAndAdminUserCommand,
  CreateUserInfoCommand,
} from '../../../../core/api/models';
import { UpdateOrganizationCommand } from '../../../../core/api/models/update-organization-command';
import { RegularExpressions } from '../../../../core/constants/regular-expressions';
import { DialogService } from '../../../../core/services/dialog.service';
import { nationalIdValidator } from '../../../../core/validators/national-id-validator';
import { DateTimeConfig } from '../../../../shared/components/date-time-picker/date-time-picker.component';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { OrganizationDto } from './../../../../core/api/models/organization-dto';
import { OrganizationsService } from './../../../../core/api/services/organizations.service';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { DateTimeService } from './../../../../core/services/date-time.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { OrganizationAdminUserFormComponent } from "../organization-admin-user-form/organization-admin-user-form.component";
import { ThemeColorPipe } from 'src/app/core/utils/theme/theme-color.pipe';


@Component({
    selector: 'app-organizations-form',
    templateUrl: './organizations-form.component.html',
    styleUrls: ['./organizations-form.component.scss'],
    imports: [BaseFormModule, OrganizationAdminUserFormComponent, ThemeColorPipe]
})
export class OrganizationsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  protected currentService = inject(OrganizationsService);
  model: any = {};
  // roleIds: number[] = [];
  user: CreateUserInfoCommand = {};
  isAllowedEditRoles: boolean = true;
  hasOpenAttribute: boolean = true;

  formPageConfig: FormPageConfig<OrganizationDto> = {};
  // expireTime;
  isSuperAdmin: boolean = true;
  isOrganizationAdmin: boolean = false;
  currentOrganizationId: number;
  isSelectedOrganizationAdmin: boolean = false;
  isShowGroupPrice: boolean = true;

  updateDistinctUsersList: number = 1;
  dateTimeConfig: DateTimeConfig;
  sendStartTime: any;
  sendEndTime: any;
  userForm: FormGroup;

  //#endregion

  constructor(
    public dialogService: DialogService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.changeValidation();
    this.getUserState();
    this.getIsOrganizationAdmin();
    this.isMainOrganization();
    this.formChangesInSuperAdminOrganization();
    this.isDisableTimeFields();
  }

  isDisableTimeFields() {
    if (this.currentUserInfo.organizationId != 1) {
      this.form.get('systemInformation').get('sendStartTime').disable();
      this.form.get('systemInformation').get('sendEndTime').disable();
      this.form.get('systemInformation').get('isActiveAllTime').disable();
      this.form.get('systemInformation').get('isAllowLink').disable();
      this.form.get('systemInformation').get('isPostpaid').disable();
      this.form.get('systemInformation').get('isCanSendExtraReceivers').disable();
    }
  }

  isMainOrganization() {
    if (this.model.id == 1) {
      this.form.get('systemInformation').get('parentId').disable();
      this.form.get('systemInformation').get('domainId').disable();
    }
  }

  setComponentsConfig() {
    try {
      this.dateTimeConfig = {
        dateLabel: 'common.expireDate',
        timeLabel: 'common.expireTime',
        dateFormControl: this.form?.get(
          'systemInformation.expireDate'
        ) as FormControl,
        timeFormControl: this.form?.get(
          'systemInformation.expireTime'
        ) as FormControl,
        minDateType: 'today',
        isDefaultValue: false,
        isConvertToIsoString: false,
        responsiveClassName: 'md:tw-w-1/2',
        dateTimeValue: this.formPageConfig.isEditMode
          ? this.model.expireDate
          : DateTimeService.combineDateTimeToUTC(
              this.model.expireDate,
              '00:00'
            ),
        isEditMode: this.formPageConfig.isEditMode,
      };
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  getIsOrganizationAdmin() {
    try {
      this.isSelectedOrganizationAdmin =
        this.currentOrganizationId ==
        +this.formPageConfig?.editData?.id?.toString();

      const systemInformationSection = this.form.get('systemInformation');

      if (!this.isSelectedOrganizationAdmin || this.currentOrganizationId == 1)
        systemInformationSection.enable();
      else {
        systemInformationSection.disable();
        this.isAllowedEditRoles = false;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#region init methods

  initForm() {
    this.form = new FormGroup({
      generalInformation: new FormGroup({
        isRealPerson: new FormControl('', Validators.required),
        name: new FormControl('', [Validators.required]),
        nationalId: new FormControl(''),
        phone: new FormControl('', Validator.phone),
        ceoName: new FormControl(''),
        ceoMobile: new FormControl('', Validator.mobile), //حقوقی
        ceoNationalCode: new FormControl(''),
        economicCode: new FormControl('', [Validators.required]), //حقوقی
        zipCode: new FormControl('', Validator.zipCode),
        address: new FormControl('', Validators.required),
        isForeigner: new FormControl(''),
      }),
      systemInformation: new FormGroup({
        parentId: new FormControl('', Validators.required),
        adminUserId: new FormControl(''),
        blackSenderPrivateNumberId: new FormControl(''),
        domainId: new FormControl('', Validators.required),
        maximumUser: new FormControl('', [Validators.required]),
        maximumPhoneNumber: new FormControl('', [Validators.required]),
        maxOrganization: new FormControl('', [Validators.required]),
        maxPhonebook: new FormControl('', [Validators.required]),
        maxCustomFiled: new FormControl('', [Validators.required]),
        panelPrice: new FormControl('', [Validators.required]),
        sendEndTime: new FormControl('', Validators.required),
        sendStartTime: new FormControl('', Validators.required),
        expireDate: new FormControl('', Validators.required),
        expireTime: new FormControl('', Validators.required),
        signature: new FormControl(''),
        header: new FormControl(''),
        groupPriceCategoryId: new FormControl('', Validators.required),
        groupPriceId: new FormControl('', Validators.required),
        descriptions: new FormControl(''),
        isActive: new FormControl(''),
        isAllowLink: new FormControl(''),
        isActiveSend: new FormControl(''),
        isConfirmMessage: new FormControl(''),
        isHaveBlackListDeliveryProcess: new FormControl(''),
        isActiveAllTime: new FormControl(''),
        isTax: new FormControl(''),
        isShowGeneralNumbers: new FormControl(''),
        isShowGeneralAccount: new FormControl(''),
        isCanSeePublicParentPhonebook: new FormControl(''),
        isSendAlertToOrganizationAdmin: new FormControl(''),
        isSendAlertForCreateSmartSmsRequest: new FormControl(''),
        isSendOrganizationExpirationAlertMessage: new FormControl(''),
        isSendAlertForCreatePayment: new FormControl(''),
        isSendAlertForCreateOnlinePayment: new FormControl(''),
        isPostpaid: new FormControl(''),
        isCanSendExtraReceivers: new FormControl(''),
      }),
    });
  }

  initModel() {
    try {
      this.model = {
        isShowGeneralAccount: false,
        isShowGeneralNumbers: false,
        isTax: false,
        isRealPerson: false,
        isForeigner: false,
        isActive: false,
        isActiveSend: false,
        isAllowLink: false,
        maximumUser: -1,
        maxOrganization: -1,
        maxPhonebook: -1,
        maximumPhoneNumber: -1,
        maxCustomFiled: -1,
        expireDate: DateTimeService.getAYearLaterToIsoString(),
        // sendStartTime: '00:00',
        // sendEndTime: '21:00',
      };
      // super.initModel();
      this.sendStartTime = '08:00';
      this.sendEndTime = '21:00';

      if (this.formPageConfig.isEditMode) {
        this.model = cloneDeep(this.formPageConfig.editData);
        this.sendStartTime = this.model.sendStartTime.removeTimeSeconds();
        this.sendEndTime = this.model.sendEndTime.removeTimeSeconds();
      } else this.formPageConfig.editData = {};

      if (!this.formPageConfig.isEditMode) {
        this.model.roleIds = [];
      }

      this.setComponentsConfig();
      this.user = {};

      this.currentOrganizationId = this.currentUserInfo?.organizationId;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  formChangesInSuperAdminOrganization() {
    if (this.formPageConfig.editData.id != 1 || !this.formPageConfig.isEditMode)
      return;
    this.form.get('systemInformation').get('parentId').clearValidators();
    this.form.get('systemInformation').get('parentId').updateValueAndValidity();
  }

  defaultValues() {}

  //#endregion

  //#region form validations

  changeValidation() {
    this.clearValidation();

    if (this.model.isRealPerson) {
      if (this.formPageConfig.isEditMode) {
        if (!this.model.isForeigner)
          this.form
            .get('generalInformation')
            .get('nationalId')
            .setValidators(Validator.nationalCode);
        else
          this.form
            .get('generalInformation')
            .get('nationalId')
            .setValidators([
              Validators.required,
              Validators.maxLength(12),
              Validators.minLength(12),
              Validators.pattern(RegularExpressions.justNumber),
            ]);
      }
    } else {
      this.form
        .get('generalInformation')
        .get('ceoName')
        .setValidators([Validators.required, Validators.maxLength(64)]);
      this.form
        .get('generalInformation')
        .get('ceoMobile')
        .setValidators(Validator.mobile);
      this.form
        .get('generalInformation')
        .get('ceoNationalCode')
        .setValidators(Validator.nationalCode);
      this.form
        .get('generalInformation')
        .get('economicCode')
        .setValidators([
          Validators.required,
          Validators.maxLength(12),
          Validators.minLength(11),
          Validators.pattern(RegularExpressions.justNumber),
        ]);
      this.form
        .get('generalInformation')
        .get('nationalId')
        .setValidators([
          Validators.required,
          Validators.maxLength(11),
          Validators.minLength(11),
          nationalIdValidator(),

          Validators.pattern(RegularExpressions.justNumber),
        ]);
    }

    this.updateValidation();
  }

  clearValidation() {
    this.form.get('generalInformation').get('ceoName').clearValidators();
    this.form.get('generalInformation').get('ceoMobile').clearValidators();
    this.form.get('generalInformation').get('nationalId').clearValidators();
    this.form
      .get('generalInformation')
      .get('ceoNationalCode')
      .clearValidators();
    this.form.get('generalInformation').get('economicCode').clearValidators();
    this.form.get('generalInformation').get('isForeigner').clearValidators();
  }

  updateValidation() {
    this.form
      .get('generalInformation')
      .get('nationalId')
      .updateValueAndValidity();
    this.form.get('generalInformation').get('ceoName').updateValueAndValidity();
    this.form
      .get('generalInformation')
      .get('ceoMobile')
      .updateValueAndValidity();
    this.form
      .get('generalInformation')
      .get('ceoNationalCode')
      .updateValueAndValidity();
    this.form
      .get('generalInformation')
      .get('economicCode')
      .updateValueAndValidity();
    this.form
      .get('generalInformation')
      .get('isForeigner')
      .updateValueAndValidity();
  }

  get errorControl() {
    let validateGeneralInformations = this.form.controls
      .generalInformation as FormGroup;
    return validateGeneralInformations.controls;
  }

  get errorControlSystemInformation() {
    let validateSystemInformation = this.form.controls
      .systemInformation as FormGroup;
    return validateSystemInformation.controls;
  }
  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateOrganizationAndAdminUserCommand) {
    this.unSubs();

    this.loading = true;
    try {
      if (
        model.organization.sendStartTime.length < 8 &&
        model.organization.sendEndTime.length < 8
      ) {
        model.organization.sendStartTime = DateTimeService.addSecondsToTime(
          model.organization.sendStartTime
        );
        model.organization.sendEndTime = DateTimeService.addSecondsToTime(
          model.organization.sendEndTime
        );
      }

      model.organization.isForeigner = this.user.isForeigner ? true : false;
      if (model.organization.isRealPerson)
        model.organization.nationalId = this.user.nationalCode;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }

    this.currentService
      .organizationsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  } 

  //Update
  baseUpdateApi(model: UpdateOrganizationCommand) {
    this.unSubs();

    this.loading = true;
    try {
      model.id = this.formPageConfig.editId;

      if (model.sendStartTime.length < 8 && model.sendEndTime.length < 8) {
        model.sendStartTime = DateTimeService.addSecondsToTime(
          model.sendStartTime
        );
        model.sendEndTime = DateTimeService.addSecondsToTime(model.sendEndTime);
      }

      if (!model.isForeigner) model.isForeigner = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }

    this.currentService
      .organizationsUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onChangeParentId(event) {
    if (this.formPageConfig.editData.parentId == event) {
      ConsoleService.info('ok');

      return;
    }
    this.model.groupPriceCategoryId = null;
    this.model.groupPriceId = null;
    // this.roleIds = [];
    this.model.roleIds = [];
  }

  convertMobile() {
    // this.model.ceoMobile = this.model.ceoMobile.convertMobileNumberPrefixTo98().trim();
    // this.form.get('ceoMobile').updateValueAndValidity();
  }

  changeTimeValidation(isChecked) {
    if (isChecked) {
      this.form.get('systemInformation').get('sendStartTime').clearValidators();
      this.form.get('systemInformation').get('sendEndTime').clearValidators();
      this.form
        .get('systemInformation')
        .get('sendEndTime')
        .updateValueAndValidity();
      this.form
        .get('systemInformation')
        .get('sendStartTime')
        .updateValueAndValidity();
    } else {
      this.form
        .get('systemInformation')
        .get('sendStartTime')
        .setValidators(Validators.required);
      this.form
        .get('systemInformation')
        .get('sendEndTime')
        .setValidators(Validators.required);
      this.form
        .get('systemInformation')
        .get('sendEndTime')
        .updateValueAndValidity();
      this.form
        .get('systemInformation')
        .get('sendStartTime')
        .updateValueAndValidity();
    }
  }

  changeIsActiveAll(isChecked) {
    this.changeTimeValidation(isChecked.checked);
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (!this.formPageConfig.isEditMode)
        if (!this.isValidForm(this.userForm, this.tagName)) return;
      if (this.loading) return;

      let generalInformationForm = this.form.controls
        .generalInformation as FormGroup;
      if (!this.isAllowedEditRoles) this.model.roleIds = [];

      if (generalInformationForm.valid) {
        if (this.loading || !this.form.valid) return;

        if (this.user.expireDate)
          this.user.expireDate = DateTimeService.toUTC(this.user.expireDate);

        if (this.user.birthDate)
          this.user.birthDate = DateTimeService.toUTC(this.user.birthDate);

        this.model.sendStartTime = this.sendStartTime;
        this.model.sendEndTime = this.sendEndTime;

        if (this.formPageConfig.isEditMode) this.baseUpdateApi(this.model);
        else
          this.baseCreateApi({
            organization: this.model,
            user: this.user,
            roleIds: this.model?.roleIds,
          });
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  /**check detail element has open attribute or not */
  onCheckHasOpenAttribute(id) {
    let detailElement = document.getElementById(`${id}`);
    this.hasOpenAttribute = detailElement.hasAttribute('open');
  }
}
